import { Icon } from '@blueprint/ui';
import React, { useState } from 'react';
import {
    DynamicPhoneNumber,
    useDynamicNumber
} from '@zoopla/dynamic-phone-number';
import { Spinner } from '@zoopla/assets';
import { DynamicNumberWrapper, Loader } from './PhoneNumber.styles';

export type PhoneNumberProps = {
    phoneNumber: string;
    branchId: string;
    listingId: string;
    phoneOnClick?: () => void;
    phoneRevealOnClick?: () => void;
};

const DYNAMIC_NUMBER_FETCH_TIMEOUT = 2000;

const PhoneNumber = ({
    phoneNumber,
    branchId,
    listingId,
    phoneOnClick,
    phoneRevealOnClick
}: PhoneNumberProps) => {
    const [shownNumber, setShownNumber] = useState<string | undefined>(
        undefined
    );

    const { getDynamicNumber, dynamicPhone, loading, error } =
        useDynamicNumber();

    if (error && !shownNumber) setShownNumber(phoneNumber);

    if (dynamicPhone && !shownNumber) setShownNumber(dynamicPhone);

    const getCallText = () => {
        if (shownNumber) {
            return shownNumber;
        } else if (loading) {
            return <Loader src={Spinner} alt="loading" />;
        } else {
            return 'Call';
        }
    };

    const onRevealClick = async () => {
        phoneRevealOnClick?.();
        setTimeout(() => {
            setShownNumber((prevNumber) =>
                prevNumber ? prevNumber : phoneNumber
            );
        }, DYNAMIC_NUMBER_FETCH_TIMEOUT);

        getDynamicNumber(branchId, listingId);
    };

    return (
        <DynamicNumberWrapper>
            <DynamicPhoneNumber
                disabled={loading && shownNumber === undefined}
                onClickToCall={() => phoneOnClick && phoneOnClick()}
                onClickToReveal={onRevealClick}
                phone={shownNumber}
                data-testid="agent-dynamic-phone-cta"
            >
                <Icon iconId="phone_outline" size="medium" />
                {getCallText()}
            </DynamicPhoneNumber>
        </DynamicNumberWrapper>
    );
};

export default PhoneNumber;
